import { NgModule } from "@angular/core";
import { AuthRoutingModule } from "./auth-routing.module";
import { LoginComponent } from "./login/login.component";
import { RegisterComponent } from "./register/register.component";
// Import your library
import { NgSelectModule } from "@ng-select/ng-select";
import { SharedModule } from "../shared/shared.module";
import { GuestloginComponent } from "./login/Guest_login/guestlogin.component";
import { PopupLoginComponent } from "./popup-login/popup-login.component";
import { PopupRegisterComponent } from "./popup-register/popup-register.component";
import { PopupLoginOptionsComponent } from "./popup-login-options/popup-login-options.component";
@NgModule({
  imports: [
    SharedModule,
    AuthRoutingModule,
    NgSelectModule,
    LoginComponent,
    RegisterComponent,
    GuestloginComponent,
    PopupLoginComponent,
    PopupRegisterComponent,
    PopupLoginOptionsComponent,
  ],
  declarations: [],
})
export class AuthModule {}
